module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "350px",
      "persistent": ""
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "text--lighten-1",
    attrs: {
      "small": "",
      "light": ""
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-card', [_c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_c('h2', [_vm._v("Edit Trial Investigators")])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.editedInvestigators), function(item) {
    return _c('v-flex', {
      key: item.objectName,
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Investigator",
      "id": "InvestigatorName"
    },
    model: {
      value: (_vm.editedInvestigators),
      callback: function($$v) {
        _vm.editedInvestigators = $$v
      },
      expression: "editedInvestigators"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Investigator Phone Number",
      "id": "InvestigatorPhone"
    },
    model: {
      value: (_vm.editedInvestigatorsPhone),
      callback: function($$v) {
        _vm.editedInvestigatorsPhone = $$v
      },
      expression: "editedInvestigatorsPhone"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Investigator Email Address",
      "id": "InvestigatorEmail"
    },
    model: {
      value: (_vm.editedInvestigatorsEmail),
      callback: function($$v) {
        _vm.editedInvestigatorsEmail = $$v
      },
      expression: "editedInvestigatorsEmail"
    }
  })], 1)], 2), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-btn', {
    staticClass: "grey lighten-1 white--text",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text cyan ",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": _vm.onSaveChanges
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    staticClass: "red darken-3",
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.onDeleteInvestigator(_vm.investigator)
      }
    }
  }, [_c('v-icon', {
    staticClass: "text--lighten-1",
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("delete")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e470ad8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Investigators/Edit/EditInvestigatorsDialog.vue
// module id = 707
// module chunks = 1